import { render, staticRenderFns } from "./TaskCostOverview.vue?vue&type=template&id=cf28e45e&scoped=true&"
import script from "./TaskCostOverview.vue?vue&type=script&lang=js&"
export * from "./TaskCostOverview.vue?vue&type=script&lang=js&"
import style0 from "./TaskCostOverview.vue?vue&type=style&index=0&id=cf28e45e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf28e45e",
  null
  
)

export default component.exports